<div class="insight-container">

  <div class="report-menu">
    <div class="report-title-with-actions">
      <div class="report-name">
        Storm Report
      </div>

      <div class="report-menu__actions">
        <button
          mat-icon-button
          class="report-button"
          (click)="addStorm()"
          [matTooltip]="'Add Storm Event'"
        >
          <mat-icon class="action-icon">add</mat-icon>
        </button>

        <app-filter-button [appliedFiltersCount]="appliedFiltersCount"
                           [active]="showingFilterBar"
                           (toggled)="toggleFilter()"
        ></app-filter-button>

        <button
          mat-icon-button
          class="report-button"
          (click)="closeInsight()"
          [matTooltip]="'Close'"
        >
          <mat-icon class="action-icon">close</mat-icon>
        </button>
      </div>
    </div>

    <div class="report-subtitle">
      Retrieve shift data in pre-defined time ranges
    </div>
  </div>

  <app-filter-bar
    class="report-menu__filters"
    [origin]="'stormReport'"
    [showingFilterBar]="showingFilterBar"
    [useDateFilter]="true"
    (dateFilterChanged)="dateFilterChanged($event)"
    (appliedFiltersChanged)="appliedFiltersCount = $event"
  >
  </app-filter-bar>

  <div class="report__table__wrapper"
       [ngClass]="{'report-table-with-filter-bar': showingFilterBar}"
  >
    <app-storm-report-table
      [dataSource]="dataSource"
      (sortChangedEvent)="loadReport()"
      (scrolledToBottomEvent)="extendReport()"
    >
    </app-storm-report-table>
  </div>
</div>
